
import "../../App.css"
import { Card, Row, Col, Form, Tab, Tabs, Button } from 'react-bootstrap';
import { useState } from 'react';
import studentimg from "../../asset/images/portal/studentlogin.png"
import instituteimg from "../../asset/images/portal/loginimg.png"
import "../../asset/css/tab.css"
import UserService from '../../service/UserService';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function Login({ onSwitchPage }) {
    const [key, setKey] = useState('student');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

   
    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const userData = await UserService.login(username, password);
            console.log("UserData", userData);
    
            if (userData.token) {
                const userRole = userData.userInfo.role.id;
                localStorage.setItem('token', userData.token);
                localStorage.setItem('email', userData.email);
                localStorage.setItem('id', userData.userInfo.id);
                localStorage.setItem("lastActivity", Date.now());
                
                if (key === 'student' && userRole === 3) { 
                    console.log("Navigating to StudentDashboard");
                    navigate('/student-instruction');
                } else if (key === 'institute' && userRole === 2) { 
                    console.log("Navigating to InstituteDashboard");
                    navigate('/institute-dashboard');
                } else {
                    alert("Unauthorized access. Please ensure you're logging in as the correct user type.");
                }
            } else {
                alert("Invalid credentials. Please try again.");
            }
        } catch (error) {
            console.error("Login error:", error);
            alert("An error occurred during login. Please try again.");
        }
    };
    
    return (
        <>
            <div id="loginpage" className="loginpage">
                <Card className='mt-2'>
                    <Card.Body className='display_center'>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab className='tablink' eventKey="student" title="Student">
                                <div className='text_c'>
                                    <p style={{ marginBottom: "-1rem" }}>Please enter your user information.</p>
                                    <Card.Img variant="top" src={studentimg} className='loginimg' />
                                </div>
                                <Form style={{ marginTop: "-20px" }}>
                                    <Form.Group as={Row} className="mb-2" >
                                        <Form.Label >
                                            Email
                                        </Form.Label>
                                        <Col>
                                            <Form.Control type="text" placeholder="email@example.com" value={username} onChange={(e) => setUsername(e.target.value)} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label >
                                            Password
                                        </Form.Label>
                                        <Col>
                                            <Form.Control type={showPassword ? "text" : "password"} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: "10px",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    zIndex: 10,
                                                }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} />}
                                            </span>
                                        </Col>
                                    </Form.Group>

                                    <div style={{ marginTop: "15px" }}>
                                        <Button variant="contained" className="button " onClick={handleLogin}>
                                            Login
                                        </Button>
                                    </div>

                                    <div className='mt-2'>
                                        <span
                                            onClick={onSwitchPage}
                                            className="fs-5 text-primary signupspan "
                                            style={{ cursor: "pointer" }}
                                        >
                                            Create An Account
                                        </span>
                                    </div>
                                </Form>
                            </Tab>

                            <Tab className='tablink' eventKey="institute" title="Institute">
                                <div className='text_c'>
                                    <p style={{ marginBottom: "-1rem" }}> Login your account</p>
                                    <Card.Img variant="top" src={instituteimg} className='loginimg' />
                                </div>
                                <Form style={{ marginTop: "-20px" }}>
                                    <Form.Group as={Row} className="mb-2" >
                                        <Form.Label >
                                            Email
                                        </Form.Label>
                                        <Col>
                                            <Form.Control type="text" placeholder="email@example.com" value={username} onChange={(e) => setUsername(e.target.value)} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label >
                                            Password
                                        </Form.Label>
                                        <Col>
                                            <Form.Control type={showPassword ? "text" : "password"} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                            <span
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: "10px",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    zIndex: 10,
                                                }}
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                {showPassword ? <VisibilityIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} /> : <VisibilityOffIcon style={{ color: "#8697c4", fontSize: "20px", marginRight: "10px" }} />}
                                            </span>
                                        </Col>
                                    </Form.Group>
                                    <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                                        <Button variant="contained" className="button " onClick={handleLogin} >
                                            Login
                                        </Button></div>
                                </Form>
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
}
export default Login;